module.exports = __webpack_public_path__ + "img/homeTipBg2.bbd7df61.png";